import React, { ReactElement, useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import { ReplaceURLs, getLevelColor } from '../../../../common/utils/utils';
import { LiveProps } from '../../LiveContainer';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import officalLiverIcon from '../../../../assets/svg/officialliver_icon.svg';
import { actions } from '../../liveSlice';
import {
  useAddBlockMutation,
  usePostFollowMutation,
  useUnFollowMutation,
} from '../../../../services/api/apiProvider';
import { updateFollowing } from '../../../profile/slices/profilePageSlice';

const LiveProfileModal = (props: LiveProps): ReactElement => {
  const dispatch = useDispatch();

  const { userData, isFollowing } = useSelector(
    (state: AppState) => state.profilePageState,
  );

  const [postFollow] = usePostFollowMutation();
  const [unFollow] = useUnFollowMutation();
  const [addBlock] = useAddBlockMutation();
  const [statusFollow, setStatusFollow] = useState<boolean>(
    userData?.followStatus === 'following',
  );

  const handleCloseModalProfile = () => {
    dispatch(actions.toggleProfileModal(false));
  };

  useEffect(() => {
    if (userData?.user.id === props.liveState.liveData?.user.id) {
      dispatch(updateFollowing(userData?.followStatus === 'following'));
    } else {
      setStatusFollow(userData?.followStatus === 'following');
    }
    setTimeout(() => {
      const modifiedStr = ReplaceURLs(userData?.user.description.value);
      const element = document.getElementById('text-target');
      if (element) {
        if (modifiedStr) {
          element.innerHTML = modifiedStr;
        } else element.innerHTML = '';
      }
    }, 150);
  }, [userData]);

  const handleFollow = async () => {
    if (userData) {
      if (userData?.user.id === props.liveState.liveData?.user.id) {
        if (isFollowing) {
          await unFollow(userData.user.id).unwrap();
          dispatch(updateFollowing(!isFollowing));
        } else {
          await postFollow(userData.user.id).unwrap();
          dispatch(updateFollowing(!isFollowing));
        }
      } else {
        if (statusFollow) {
          await unFollow(userData.user.id).unwrap();
          setStatusFollow(!statusFollow);
        } else {
          await postFollow(userData.user.id).unwrap();
          setStatusFollow(!statusFollow);
        }
      }
    }
  };

  const handleBlock = async () => {
    if (userData) {
      await addBlock({ id: userData.user.id });
      dispatch(actions.toggleProfileModal(false));
      dispatch(actions.toggleConfirmBlockedModal(true));
    }
  };

  const renderUserProfile = () => {
    if (!userData) {
      return (
        <div className="block-group__loading">
          <Spinner
            animation="border"
            style={{ color: 'var(--color-primary)' }}
          />
        </div>
      );
    }
    if (userData) {
      return (
        <div className="container">
          <div className="profile">
            <div className="profile__user-info ">
              <div className="profile__avatar">
                <ImageCustom src={userData.user.picture.uri} />
              </div>

              <div className="profile__name">
                <span
                  className="profile__level"
                  style={{
                    backgroundColor: getLevelColor(userData.user.level),
                  }}
                >
                  {`Lv.${userData.user.level}`}
                </span>
                <span>{userData.user.loginId}</span>
                {userData.user.isCertifiedLiver && (
                  <img
                    className="profile__offical-icon"
                    src={officalLiverIcon}
                  />
                )}
              </div>

              <div className="profile__stats">
                <div className="profile__stats-item">
                  <div className="profile__stats-item__number">
                    {userData.followerCount}
                  </div>
                  <div className="profile__stats-item__text">フォロワー</div>
                </div>
                <div className="profile__stats-item">
                  <div className="profile__stats-item__number">
                    {userData.followingCount}
                  </div>
                  <div className="profile__stats-item__text">フォロー中</div>
                </div>
                <div className="profile__stats-item">
                  <div className="profile__stats-item__number">
                    {userData.niceCount}
                  </div>
                  <div className="profile__stats-item__text">いいね</div>
                </div>
              </div>

              <div className="profile__catch-phrase">
                {userData.user.catchPhrase.value}
              </div>

              <div id="text-target" className="profile__description"></div>

              {userData.user.id === props.liveState.userData?.id ? (
                <></>
              ) : (
                <div onClick={handleFollow}>
                  {userData.user.id === props.liveState.liveData?.user.id ? (
                    <>
                      {isFollowing ? (
                        <div className="profile__edit-btn background-follow">
                          フォロー中
                        </div>
                      ) : (
                        <div className="profile__edit-btn">フォロー</div>
                      )}
                    </>
                  ) : (
                    <>
                      {statusFollow ? (
                        <div className="profile__edit-btn background-follow">
                          フォロー中
                        </div>
                      ) : (
                        <div className="profile__edit-btn">フォロー</div>
                      )}
                    </>
                  )}
                </div>
              )}
              {props.liveState.role === 'host' &&
                userData.user.id !== props.liveState.liveData?.user.id && (
                  <div
                    className="profile__edit-btn btn-block"
                    onClick={handleBlock}
                  >
                    ブロック
                  </div>
                )}
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <Modal
      show={props.liveState.isShowProfileModal}
      onHide={handleCloseModalProfile}
      backdrop="static"
      keyboard={false}
      centered
      scrollable={true}
    >
      <Modal.Header closeButton onHide={handleCloseModalProfile}></Modal.Header>
      <Modal.Body>{renderUserProfile()}</Modal.Body>
    </Modal>
  );
};

export default LiveProfileModal;
